// Modul zur Anzeige von Antragsdaten
"use strict";

import module from "./module.js";

export default module;
